export const SET_DASHBOARD_EDIT_MODE = 'SET_DASHBOARD_EDIT_MODE';

export const setDashboardEditMode = (value) => ({
  type: SET_DASHBOARD_EDIT_MODE,
  value
});
